import { render, staticRenderFns } from "./DGallery.vue?vue&type=template&id=105afb55&"
import script from "./DGallery.vue?vue&type=script&lang=js&"
export * from "./DGallery.vue?vue&type=script&lang=js&"
import style0 from "./DGallery.vue?vue&type=style&index=0&id=105afb55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports